module.exports = __webpack_public_path__ + "static/T6-d1ccbabbfdd3b1efb355875e116297ea.jpg";